import { useContext } from "react";
import { AuthContext } from "./AuthContext";

const useAuth = (): AuthContext => {
    return useContext(AuthContext);
};

export default useAuth;
